// src/components/Partners.js
import React from 'react';
import './Partners.css';
import uniconLogoWhite from '../assets/Unicon-Logo-White.webp';
import { Link } from 'react-router-dom';

const Partners = () => {
  return (
    <section className="partnersSection">
      <header className="partnersHeader">
        <h2>Our Partners</h2>
        <p>Partnering with Nexed Insight to shape the future of business education—and its impact on individuals, organizations, and society.</p>
      </header>
      <div className="partnersGrid">
        <div className="partnerItemMain">
          <h4>Our Founding Partner</h4>
          <img
            src={uniconLogoWhite}
            alt="UNICON"
            className="partnerBottomImage"
          />
          <p>
            We are extremely proud to have UNICON as a founding partner of Nexed Insight. As the global consortium for university-based executive education, UNICON has long been at the forefront of advancing the impact of business education. Having worked closely with UNICON for the past five years, we understand first-hand their deep commitment to fostering innovation, collaboration, and excellence in executive education. In both mission, values and expertise there could be no better-aligned partner to help shape this initiative. UNICON’s knowledge, networks, and global perspective will be invaluable as we work together to generate world-leading research insights and strategic foresight for the sector.
          </p>
          <Link to="/unicon" className="foundingPartnerLink">
  Find out more about our partnership with UNICON
</Link>
        </div>
        <div className="partnerItem">
          <h4>Associate Partners</h4>
          <p>
            Nexed Insight is building a network of forward-thinking associate partners committed to shaping the future of business education and corporate learning. Becoming an Associate Partner offers a platform for brand alignment with key industry themes, visibility among influential decision-makers, and opportunities to support and contribute to thought leadership that drives meaningful impact.
          </p>
          <p>
            Is your brand aligned with our goals?{' '}
            <a href="/contact" className="partnerLink">
              Get in touch to explore associate partnerships
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Partners;
